import type { ReactNode } from 'react';
import React, { forwardRef } from 'react';

import { FlexProps } from '@rover/kibble/core';
import { PositionSystemType } from '@rover/kibble/core/styledSystemPropTypes';

import BaseCarousel from '../BaseCarousel';
import {
  OnScrollEventHooks,
  ScrollMarginProperties,
  ScrollPaddingProperties,
  ScrollSnapStop,
} from '../types';

export type Props = {
  /** The components to be rendered inside the carousel (e.g., cards) */
  children: ReactNode;
  gap?: FlexProps['gap'];
  scrollSnapAlign?: 'center' | 'start' | 'end';
  /** Default 'always' preserves existing behavior for every other consumer of this component. */
  scrollSnapStop?: ScrollSnapStop;
  showScrollbar?: boolean;
  position?: PositionSystemType;
} & ScrollMarginProperties &
  ScrollPaddingProperties &
  OnScrollEventHooks;

/**
 * A SnappingCarousel component that leverages the BaseCarousel component,
 * This component is explicitly for pagination with snapping cards into place.
 */
const SnappingCarousel = forwardRef<HTMLElement, Props>(
  (
    {
      children,
      scrollSnapAlign = 'start',
      scrollSnapStop = 'always',
      position = 'static',
      ...rest
    },
    ref
  ) => {
    return (
      <BaseCarousel
        ref={ref}
        scrollSnapAlign={scrollSnapAlign}
        scrollSnapType="x mandatory"
        scrollSnapStop={scrollSnapStop}
        position={position}
        {...rest}
      >
        {children}
      </BaseCarousel>
    );
  }
);

export default SnappingCarousel;
